import { ImportProfile } from '../models/common.models';

import { mutationTypes, stateTypes } from './common.moduletypes';

const mutations = {
  [mutationTypes.setSchedule](state, data) {
    state[stateTypes.schedule] = data;
  },
  [mutationTypes.setSchedules](state, data) {
    state[stateTypes.schedules] = data.units;
  },
  [mutationTypes.setUserProfile](state, data) {
    let profile = new ImportProfile(data);
    state[stateTypes.userProfile] = profile;
  },
  [mutationTypes.updateUserProfile](state, data) {
    let userProfile = state[stateTypes.userProfile];
    userProfile = { ...userProfile, ...data };
    state[stateTypes.userProfile] = userProfile;
  },
  [mutationTypes.setRegions](state, data) {
    state[stateTypes.regions] = data;
  },
  [mutationTypes.setOneNews](state, data) {
    state[stateTypes.oneNews] = data;
  },
  [mutationTypes.setAllNews](state, data) {
    state[stateTypes.news] = data;
  },
  [mutationTypes.setRecommendations](state, data) {
    state[stateTypes.recommendations] = data;
  },
  [mutationTypes.setWireOems](state, data) {
    state[stateTypes.wireOems] = data;
  },
  [mutationTypes.setLogData](state, { data, lastPage, resetPreviousData }) {
    let { hasMoreEntries, logDate } = data;
    let oldData = resetPreviousData ? [] : state[stateTypes.logData].data;
    state[stateTypes.logData].data = [...oldData, ...logDate];
    state[stateTypes.logData].hasMoreEntries = hasMoreEntries;
    state[stateTypes.logData].lastPageLoaded = lastPage;
  },
  [mutationTypes.setLogFilterData](state, data) {
    state[stateTypes.filterLogData] = data;
  },
  [mutationTypes.setNotificationSettings](state, data) {
    state[stateTypes.notificationSettings] = data;
  }
};

export default mutations;
